<template>
  <bg-style class="recharge-widget overflow-x-auto" :class="{ 'is-mobile': device === DeviceEnum.MOBILE }" :style="getStyle" :mobile-bg="model.mobileBackground" :bg="model.background">
    <module-block>
      <div class="recharge-widget__content relative">
        <rich-text v-if="model.titleVisible" v-model="model.title" :stroke.sync="model.titleStroke" class="mb-5 recharge-activity__title" :editing="editing" :disabled="!editing" placement="bottom" theme="snow" />
        <div class="recharge-widget__content__list">
          <div v-for="(item, index) in model.list" :key="index" class="item-box">
            <bg-style :bg="item.background" :radius="model.radius" class="item" :style="getTextColor(item.faceColor, item.faceColorShow)" @click.native="handlePay(item)">
              <template v-if="item.faceId !== RechargeAnyValueId">
                <div class="thumb" />
                <div class="price flex justify-center items-center">
                  <span>{{ getPrice(item.faceId, index)?.price }}</span>
                  <template v-if="getFreePrice(item.faceId)">
                    <span>+</span>
                    <span>{{ getFreePrice(item.faceId) }}</span>
                  </template>
                </div>
                <div class="name relative">
                  <div>{{ getPrice(item.faceId, index)?.price }}</div>
                  <div>{{ getGoodsId(item.faceId).item_name || item.name  }}</div>
                </div>
                <div class="buy-btn">
                  <span>{{ currencyLabel }}{{ getPrice(item.faceId, index)?.price }}</span>
                </div>
              </template>
              <template v-else>
                <div class="thumb" />
                <div class="price flex justify-center items-center">
                  <span>{{ anyValue || '****' }}</span>
                  <template v-if="anyValueFree">
                    <span>+</span>
                    <span>{{ anyValueFree }}</span>
                  </template>
                </div>
                <div class="name relative">
                  <div>{{ anyValue || '****' }}</div>
                  <div>{{ getGoodsId(model.list[0].faceId).item_name || item.name  }}</div>
                </div>
                <div class="input-box">
                  <input v-model="anyValue" class="relative price-input" :class="{ 'has-value': anyValue }" :placeholder="$t('siteBuild.enterAmount')" @keyup="anyValue=String(anyValue).replace(/^(0+)|[^\d]+/g,'')" @click.stop />
                </div>
              </template>
            </bg-style>
          </div>
        </div>
        <rich-text v-model="model.activityTitle" class="recharge-activity__mobile-title mt-5" :stroke.sync="model.titleStroke" :disabled="!editing" :editing="editing" theme="snow" />
      </div>
    </module-block>
    <desk-pay-modal v-if="deskPay.visible" :desk-pay="deskPay" :lang-id-data="$store.state.locale.langIdData" @close="closePayModal" />
  </bg-style>
</template>

<script>
import {mapState} from 'vuex'
import {Message} from "element-ui"
import cloneDeep from "lodash.clonedeep"
import moment from 'moment'
import Bus from '~/site/model/bus'
import tools, { formatSpePrice, getTextColor, checkUser, checkIgnoreMessage, getDeviceType } from '~/utils'
import { RechargeAnyValueId } from '~/enums/siteEnum'
import {DeviceEnum} from "~/enums/deviceEnum"
import DeskPayModal from "~/components/pay/deskPayModal.vue"
import {isMobile} from "~/utils/types"
import {isBuildWebSite, PAY_URL} from "~/config"
import {DefaultImage} from "~/enums/defaultImageEnum"
import RichText from '~/components/richText/index.vue'
import ModuleBlock from '~/components/common/ModuleBlock.vue'

const isSandBox = !isBuildWebSite
export default {
  name: 'RechargeWidget',
  components: {
    ModuleBlock,
    RichText,
    DeskPayModal
  },
  props: {
    device: {
      type: String,
      default: ''
    },
    editing: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default() {
        return {}
      }
    }
  },
  data() {
    return {
      RechargeAnyValueId,
      getTextColor,
      anyValue: '',
      activityRes: {
        activity_rule: {
          quota: 0
        }
      },
      deskPay: {
        visible: false,
        isGoPay: false,
        payUrl: '',
        orderCode: ''
      }
    }
  },
  computed: {
    anyValueFree() {
      let value
      const number = Number(this.anyValue) * this.$store.state.project.rechargeActivity.percent
      if (number > 0) {
        value = formatSpePrice(number)
      }
      return value
    },
    DeviceEnum() {
      return DeviceEnum
    },
    currency() {
      return tools.getLangByip(this)
    },
    ...mapState({
      userInfo: (state) => state.user.siteUserInfo
    }),
    currencyLabel() {
      return this.$store.state.project.currencieMap[this.currency.currency]?.label
    },
    awaitGoods() {
      return this.$store.state.site.awaitGoods
    },
    getStyle() {
      return {
        '--recharge-column': this.model.column,
        '--recharge-mobile-column': this.model.mobileColumn,
        '--face-color': getTextColor(this.model.faceColor).color,
        '--name-color': getTextColor(this.model.nameColor).color,
        '--button-bg-color': getTextColor(this.model.buttonBackground).color,
        '--button-text-color': getTextColor(this.model.buttonColor).color,
        '--card-radius-px': this.model.radius + 'px',
        '--card-shadow-px': this.model.boxShadow + 'px'
      }
    }
  },
  mounted() {
    this.init()
    Bus.$on('reloadGood', (type) => {
      const isLogin = type === 'login'
      if (isLogin) {
        this.checkBuy()
      }
    })
    Bus.$on('reloadActivity', async () => {
      await this.getActivityData()
    })
  },
  methods: {
    async getActivityData() {
      const now_stem = Math.floor(moment().utc().valueOf() / 1000)
      const [err, res] = await this.$utils.to(this.$api.activity.getActivityList({ now_time: now_stem, player_id: (this.userInfo?.uid || '').trim(), project_id: this.$store.state.project?.projectId, activity_type: 6, status: 2}, {editing: this.editing}))
      if (!err && res?.list) {
        const data = cloneDeep(res?.list?.[0] || {})
        data.activity_rule = JSON.parse(data.activity_rule)
        this.activityRes = data
        this.$store.commit('project/SET_RECHARGE_ACTIVITY', data.activity_rule)
      }
    },
    checkBuy() {
      const isAim = this.awaitGoods && (this.awaitGoods.modelId === this.model.id)
      isAim && this.createOrder(this.awaitGoods.data)
    },
    closePayModal() {
      this.deskPay = {
        visible: false,
        isGoPay: false,
        payUrl: '',
        orderCode: ''
      }
      Bus.$emit('reloadActivity', 'payment')
    },
    async handlePay(item) {
      const isAnyFace = item.faceId === RechargeAnyValueId
      if (isAnyFace && !(+this.anyValue)) {
        return
      }
      await checkUser(this, () => {
        this.$store.commit('site/SET_AWAIT_GOODS', { modelId: this.model.id, data: cloneDeep(item) })
      })
      await this.createOrder(item)
    },
    getFreePrice(id) {
      const price = this.getPrice(id)?.price || 0
      let result = null
      const value = Number(price * this.$store.state.project.rechargeActivity.percent)
      if (value > 0) {
        result = formatSpePrice(value)
      }
      return result
    },
    async createOrder(item) {
      const return_url = `${window.location.protocol}//${window.location.host}${window.location.pathname}?from=${this.$route.query?.from}`
      const isPreviewMode = !isBuildWebSite
      const isAnyFace = item.faceId === RechargeAnyValueId
      const faceId = Number(isAnyFace ? 0 : item.faceId)
      const priceSetting = this.$store.getters.rechargeValuePriceSettingMap[faceId]
      const {
        project_id,
        merchant_id
      } = this.userInfo
      const ipInfo = tools.getxfip(localStorage)
      const priceInfo = tools.getPriceInfo(priceSetting, this.currency, this)
      const price = isAnyFace ? parseFloat(+this.anyValue) : +priceInfo.price
      const device = isMobile() ? 'mobile' : 'desktop'
      const { currency } = this.currency
      const lang = tools.getNeedParamsFormRouteParams(this.$route.params)?.lang || 'en'
      const params = {
        project_id,
        source: 2,
        merchant_id,
        currency,
        amount: price,
        from_preview_mode: isPreviewMode,
        items: [
          {
            item_id: faceId,
            num: 1,
            amount: price,
            price,
            currency,
            virtual_currency: currency,
            virtual_currency_amount: price,
          },
        ],
        settings: {
          view_source: this.$route.query.from,
          device,
          language: lang,
          show_order: false,
          return_url,
          device_type: getDeviceType()
        },
      }
      const [err, res] = await this.$utils.to(this.$api.order.createOrder(params, ipInfo))
      this.$store.commit('site/SET_AWAIT_GOODS', null)
      if (!err) {
        this.openPayModal(res)
      } else {
        !checkIgnoreMessage(err) && Message.error(err)
      }
    },
    openPayModal(res) {
      const sandbox = isSandBox ? 1 : 0
      const { token, code } = res
      let payUrl = ''
      const env = process.env.RUN_ENV
      const isGoPay = token.slice(0, 2) === 'v2'
      if (isGoPay) {
        payUrl = `${PAY_URL[env]}/new-kop/payelement?access_token=${token}&sandbox=${+sandbox}`
      } else {
        payUrl = `${PAY_URL[env]}/pay/payelement?access_token=${token}&sandbox=${+sandbox}`
      }
      if (this.device === DeviceEnum.MOBILE) {
        this.$store.commit('site/SHOW_ORDER_MODAL', { code, payUrl })
      } else {
        this.deskPay = {
          visible: true,
          isGoPay,
          payUrl,
          orderCode: code
        }
      }
    },
    getPrice(id, index) {
      const priceSetting = this.$store.getters.rechargeValuePriceSettingMap[Number(id)]
      const editorMockPrice = { priceTxt: `${this.currencyLabel} ${(index + 1) * 100} ${this.currency.currency}`, price: (index + 1) * 100 }
      if (!this.editing && !priceSetting) return
      return priceSetting ? tools.getPriceInfo(priceSetting, this.currency, this) : editorMockPrice
    },
    getGoodsId(id) {
      return this.$store.getters.rechargeValueMap[Number(id)] || {}
    },
    getIcon(id) {
      const icon = this.$store.getters.rechargeValueIconMap[Number(id)]
      if (this.editing && !icon) {
        return DefaultImage.store
      } else {
        return icon
      }
    },
    async init() {
      await this.$store.dispatch('project/getCurrencyList')
      await this.$store.dispatch('project/getRechargeValues')
      await this.getActivityData()
    }
  }
}
</script>

<style scoped lang="less">
.recharge-widget {
  padding: 20px 0;
  &__content {
    &__list {
      display: grid;
      grid-template-columns: repeat(4, 1fr);
      gap: 84px;
      .item {
        width: 240px;
        height: 340px;
        cursor: pointer;
        box-shadow: 0 0 var(--card-shadow-px) rgba(0, 0, 0, 0.2);
        .thumb {
          height: 150px;
        }
        .price {
          font-size: 24px;
          font-weight: bold;
          position: relative;
          color: var(--face-color);
        }
        .name {
          text-align: center;
          margin-top: 25px;
          color: var(--name-color);
          font-size: 18px;
          font-weight: bold;
          line-height: 1;
        }
        .buy-btn {
          margin: 12px 20px 0 20px;
          height: 56px;
          background: var(--button-bg-color);
          position: relative;
          border-radius: var(--card-radius-px);
          text-align: center;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 24px;
          font-weight: bold;
          color: var(--button-text-color);
        }
        .input-box {
          margin: 12px 20px 0 20px;
          .price-input {
            .buy-btn();
            width: 100%;
            background: rgb(148,148,148);
            margin: 0;
            outline: none;
            border-radius: var(--card-radius-px);
            transition: linear 0.24s background;
            &::placeholder {
              color: white;
            }
            &.has-value {
              background: var(--button-bg-color);
            }
          }
        }
      }
    }
  }
  &.is-mobile {
    padding: 10px;
    .recharge-widget__content {
      width: 100%;
      .recharge-activity__title {
        padding: 0 11px;
      }
      .recharge-activity__mobile-title {
        padding: 0 11px;
      }
      &__list {
        padding: 0;
        grid-template-columns: repeat(3, 1fr);
        gap: 10px 1%;
      }
      .item-box {
        display: flex;
        justify-content: center;
      }
      .item {
        width: 110px;
        height: 150px;
        .thumb {
          height: 62px;
        }
        .name {
          font-size: 12px;
          margin-top: 10px;
        }
        .price {
          font-size: 14px;
        }
        .buy-btn {
          margin: 5px 15px 0 15px;
          height: 22px;
          font-size: 14px;
        }
        .input-box {
          margin: 5px 15px 0 15px;
          .price-input {
            .buy-btn();
            width: 100%;
            margin: 0;
            height: 22px;
            font-size: 14px;
            &::placeholder{
              font-size: 10px;
              position: relative;
              top: -2px;
            }
          }
        }
      }
    }
  }
}
</style>
